const avtoPathesHead = {
  city: (data, p) => ({
    title: `Производители прицепов ${p.t(data.city)}. Лучшие дилеры прицепов - АвтоБазар`,
    description: `Производители прицепов ${p.t(data.city)}. Лучшие цены на прицепы. Акции компаний ✅ адреса и телефоны дилеров ☎️ на сайте АвтоБазар`,
    header: `Производители прицепов ${p.t(data.city)}`,
    title_uk: `Виробники причепів ${p.t(data.city)}. Кращі дилери причепів - Автобазар`,
    description_uk: `Виробники причепів ${p.t(data.city)}. Кращі ціни на причепи. Акції компаній ✅ адреси і телефони дилерів ☎️ на сайті Автобазар`,
    header_uk: `Виробники причепів ${p.t(data.city)}`,
  }),
  cityMake: (data, p) => ({
    title: `Производители прицепов ${data.make} ${p.inCity}. Лучшие предложения от дилеров - АвтоБазар`,
    description: `Производители прицепов ${data.make} ${p.inCity}. Проверенные дилеры прицепов ✅ адреса и телефоны компаний ☎️ на сайте АвтоБазар`,
    header: `Производители прицепов ${data.make} ${p.inCity}`,
    title_uk: `Виробники причепів ${data.make} ${p.inCity}. Кращі пропозиції від дилерів - Автобазар`,
    description_uk: `Виробники причепів ${data.make} ${p.inCity}. Перевірені дилери причепів ✅ адреси і телефони компаній ☎️ на сайті Автобазар`,
    header_uk: `Виробники причепів ${data.make} ${p.inCity}`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/pritsepy/templates.js